export async function fetchBuildInfo(baseUrl = process.env.BASE_URL, fetchImpl = fetch) {
  const response = await fetchImpl(`${baseUrl || '/'}build-info.json`, { cache: 'no-store' })
  if (!response.ok) throw new Error(`build-info HTTP ${response.status}`)

  const contentType = response.headers && response.headers.get
    ? response.headers.get('content-type') || ''
    : ''
  const body = await response.text()
  if (/text\/html/i.test(contentType) || /^\s*</.test(body)) {
    throw new Error('build-info endpoint returned HTML')
  }

  const info = JSON.parse(body)
  if (!info || typeof info !== 'object' || Array.isArray(info)) {
    throw new Error('build-info payload is not an object')
  }
  return info
}
